import { navigate } from "gatsby-link"
import React from "react"
import { useForm } from "react-hook-form"

import Input from "../form/Input"
export default function Booking({ name, link, single, image }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({
    // defaultValues: {
    //   start: addDays(new Date(), 14),
    //   end: addDays(new Date(), 21),
    //   adults: 4,
    //   children: 2,
    // },
  })
  const onSubmit = data => {
    // const searchData = {
    //   ...data,
    //   start: format(data.start, "dd-MM-yyyy"),
    //   end: format(data.end, "dd-MM-yyyy"),
    // }
    const queryString = Object.keys(data)
      .map(key => key + "=" + data[key])
      .join("&")

    navigate(`${link}${name}&${queryString}&image=${image}`)
  }

  return (
    <div>
      <div className="w-full mx-auto">
        <form
          className="p-2 lg:p-8  container grid grid-cols-12 gap-4 mx-auto"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="col-span-12 lg:col-span-9 grid grid-cols-2  lg:grid-cols-5 gap-4 lg:gap-8">
            {/* <div>
              <label className=" text-sm font-bold font-property">
                Check-in date
                <input
                  type="date"
                  className="py-1 outline-none focus:outline-none w-full text-gray-400"
                />
              </label>
            </div> */}
            {single ? (
              <Input
                label="Booking Date"
                type="Date"
                className="w-full"
                field="BookingDate"
                register={register}
              />
            ) : null}
            {single ? null : (
              <Input
                label="Check-in Date"
                type="Date"
                className="w-full"
                field="checkIn"
                register={register}
              />
            )}

            {single ? null : (
              <Input
                label="Check-out Date"
                type="Date"
                className="w-full"
                field="checkOut"
                register={register}
              />
            )}
            <Input
              select
              label="Adults"
              type="Select"
              className="w-full"
              options={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]}
              field="adults"
              register={register}
            />
            <Input
              select
              label="Children"
              type="Select"
              className="w-full"
              options={[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]}
              field="children"
              register={register}
            />
            {/* <div>
              <label className=" text-sm font-bold font-property">
                Adults
                <select className=" py-1 outline-none focus:outline-none w-full text-gray-400">
                  {options.map((opt, key) => {
                    return (
                      <option value={opt} key={key}>
                        {opt}
                      </option>
                    )
                  })}
                </select>
              </label>
            </div> */}
            {/* <div>
              <label className=" text-sm font-bold font-property">
                Children
                <select className=" py-1 outline-none focus:outline-none w-full text-gray-400">
                  {options.map((opt, key) => {
                    return <option key={key}>{opt}</option>
                  })}
                </select>
              </label>
            </div> */}
          </div>
          <div className="col-span-12 lg:col-span-3 ml-auto">
            <button
              type="submit"
              className=" border border-black bg-black text-white w-40 h-10 justify-center items-center text-sm font-bold hover:bg-transparent hover:text-black transition ease-in-out duration-300 outline-none focus:outline-none"
            >
              Book Now
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
